module.exports = __webpack_public_path__ + "static/indodax_logo-fec9fc68205752000ede3211b8678ade.svg";